import Vue from 'vue'
import Router from 'vue-router'
import ecosystemPage from '@/views/ecosystemPage'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/',
      name: 'ecosystemPage',
      component: ecosystemPage
    }
  ]
})
